import HttpFactory from '@/mixins/http.factory';
export default {
	name:'failure',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			message: null,
			redirectToUrl: null
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self = this;
			_self.redirectToUrl = _self.$route.query.redirectToUrl;
			_self.message = _self.$route.query.message || 'Authentication failed. Please try again.';	
		},
		contactSupport() {
			window.open('mailto:support@devopsintegration.io?subject=Zendesk%20Integration%20Support&body=Describe%20your%20issue%20here');	
		},
		retryAuth() {
			if(this.redirectToUrl) {
				window.location.href =this.redirectToUrl;
			}
		},
		goToZendesk() {
			if(this.redirectToUrl) {
				window.location.href =this.redirectToUrl;
			}
		},
		closePopUp() {
			if(window.opener) {
				window.opener.postMessage('closePopup', '*');
				window.close();
			} else {
				window.close();
			}
		}
	},
	components:{}
}

